//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
/* eslint-disable object-curly-newline */
import { ref, onBeforeMount } from '@vue/composition-api'
import { useRouter, downloadAppByOS, openTab } from '@core/utils'
import { mdiPlus, mdiRefresh, mdiLock, mdiDotsVertical, mdiStar } from '@mdi/js'
import { getFieldApp } from '@api'
import themeConfig from '@themeConfig'
import { useUtils } from '@core/libs/i18n'
import { loadLanguageAsync } from '@/plugins/i18n'
import { avatarText } from '@core/utils/filter'

export default {
  setup() {
    // Same app now (it used to live on Console and jump here): the field's
    // video list is /views/video/:facility/:field/:date/:time on this origin.
    const QR_FIELD_REDIRECT_URL = `${window.location.origin}/views/video/`

    const fieldData = ref({
      end_playback_time: null,
      facility_logo: null,
      facility_name: null,
      field_name: null,
      highlight_name: null,
      highlight_owner: null,
      highlight_owner_avatar: null,
      share_user: null,
      share_user_avatar: null,
      start_playback_time: null,
      thumbnails: null,
      video_date: null,
      video_id: null,
      video_link: null,
      video_long: null,
      video_thumbnail: null,
      video_time: null,
      video_type: null,
    })
    const fieldRef = ref(null)
    const { t } = useUtils()
    const { route, router } = useRouter()

    onBeforeMount(async () => {
      loadLanguageAsync('en')

      fieldRef.value = route.value.params.id
      const response = await getFieldApp(fieldRef.value)
      if (response.ok) {
        fieldData.value = response.data

        const path = `${QR_FIELD_REDIRECT_URL}${fieldData.value.facility_id}/${fieldData.value.field_id}/all/all`
        openTab(path)
      } else router.push({ name: 'field-not-found' })
    })

    const linkApp = () => {
      openTab('')
      downloadAppByOS(
        `fanaty://addvideos?field_id=${fieldData.value.field_id}&facility_id=${fieldData.value.facility_id}`,
        `fanaty://addvideos?field_id=${fieldData.value.field_id}&facility_id=${fieldData.value.facility_id}`,
        'https://fanaty.com/download',
        true,
      )
    }

    const downloadApp = () => {
      downloadAppByOS(
        'https://play.google.com/store/apps/details?id=com.fanaty',
        'https://apps.apple.com/us/app/fanaty/id1461051554',
        'https://fanaty.com/download',
      )
    }

    return {
      fieldData,
      fieldRef,

      // methods
      linkApp,
      downloadApp,
      avatarText,

      // themeConfig
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,

      // i18n
      t,

      icons: {
        mdiPlus,
        mdiRefresh,
        mdiLock,
        mdiDotsVertical,
        mdiStar,
      },
    }
  },
}
